import { render, staticRenderFns } from "./PrintTable.vue?vue&type=template&id=2c6d4178&scoped=true"
import script from "./PrintTable.vue?vue&type=script&lang=js"
export * from "./PrintTable.vue?vue&type=script&lang=js"
import style0 from "./PrintTable.vue?vue&type=style&index=0&id=2c6d4178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d4178",
  null
  
)

export default component.exports